import React, {useState, useEffect, Component, Fragment} from "react"
import {connect} from "react-redux"
import Styled, {css} from "styled-components"
import {Line, Bar} from "react-chartjs-2"
import moment from "moment-timezone"

// UI
import {Container, Row, Col} from "@uprise/grid"
import {ProgressBar} from "@uprise/charts"
import {Card} from "@uprise/card"
import {H2, H3, H4, H5} from "@uprise/headings"
import {Medium, ExtraSmall} from "@uprise/text"
// Components
import {Switch} from "@uprise/switch"
// utils
import {retrieveResults} from "uprise-surveys/lib/surveys/getScore"
// Colors
import {backgrounds, primary, extended} from "@uprise/colors"
// spacing
import {spacing} from "@uprise/spacing"

const YourWellbeingStyle = Styled.section`
`

const SwitchWrap = Styled.div`
	min-width: 140px;
 	width: 155px;
	display: flex;
	justify-content: end;
`

const NoData = Styled.div`
      height: 149px;
`

const BarStyle = Styled.section`
      height: 250px;
`

const HeaderStyle = Styled.section`
      padding-left: 10px;
      padding-right: 10px;
      display: flex;
	flex-direction: row;
	justify-content: space-between;
	
	@media (max-width: 475px) {
		flex-direction: column;
	}
`

const Content = Styled.section`
      display: flex;
	flex-direction: row;
`

export const YourWellbeing = ({className, who5, chartOptions}) => {
	const who5Config = {
		labels: [],
		datasets: [
			{
				label: "wellbeing",
				fill: true,
				lineTension: 0.3,
				backgroundColor: extended.purple.five,
				borderColor: primary.purple,
				borderCapStyle: "butt",
				borderDash: [],
				borderDashOffset: 0.0,
				borderJoinStyle: "miter",
				pointBorderColor: primary.purple,
				pointBackgroundColor: "#fff",
				pointBorderWidth: 1,
				pointHoverRadius: 5,
				pointHoverBackgroundColor: primary.purple,
				pointHoverBorderColor: primary.purple,
				pointHoverBorderWidth: 2,
				pointRadius: 1,
				pointHitRadius: 10,
				data: []
			}
		]
	}

	const [who5Data, setwho5Data] = useState(who5Config)
	const [chartFormat, setChartFormat] = useState("YYYY")

	const getWho5Month = who5 => {
		setChartFormat("MMM")
		const currentMonth = moment().startOf("month")
		const newWho5 = Object.assign({}, who5Data)
		const scores = who5
			.filter(result => {
				if (moment(result.timestamp).format("X") > currentMonth.format("X")) {
					return result
				}
			})
			.map(result => {
				return result.score
			})

		const dates = who5
			.filter(result => {
				if (moment(result.timestamp).format("X") > currentMonth.format("X")) {
					return result
				}
			})
			.map(result => {
				return moment.unix(result.timestamp).format("DD MMM")
			})

		newWho5.labels = dates
		newWho5.datasets[0].data = scores

		setwho5Data(newWho5)
	}

	const getWho5Year = who5 => {
		setChartFormat("YYYY")
		const currentYear = moment().startOf("year")
		const newWho5 = Object.assign({}, who5Data)
		const scores = who5
			.filter(result => {
				if (moment(result.timestamp).format("X") > currentYear.format("X")) {
					return result
				}
			})
			.map(result => {
				return result.score
			})

		const dates = who5
			.filter(result => {
				if (moment(result.timestamp).format("X") > currentYear.format("X")) {
					return result
				}
			})
			.map(result => {
				return moment.unix(result.timestamp).format("DD MMM")
			})

		newWho5.labels = dates
		newWho5.datasets[0].data = scores

		setwho5Data(newWho5)
	}

	useEffect(() => {
		getWho5Year(who5)
	}, [who5])

	return (
		<Card backgroundColor={backgrounds.white} padding={spacing.s5} shadow={true}>
			<HeaderStyle>
				<H5 className='m-t-0 m-b-xs-3'>Wellbeing Score</H5>
				<SwitchWrap className='m-b-xs-6'>
					<Switch
						defaultActive='right'
						leftLabel='1 Month'
						rightLabel='1 Year'
						leftAction={() => getWho5Month(who5)}
						rightAction={() => getWho5Year(who5)}
					/>
				</SwitchWrap>
			</HeaderStyle>

			{who5Data.labels.length > 1 ? (
				<Line id='wellbeing-line' data={who5Data} options={chartOptions} />
			) : who5Data.labels.length > 0 ? (
				<Bar id='wellbeing-bar' data={who5Data} width={200} height={100} options={chartOptions} />
			) : (
				<NoData>
					<Medium marginTop='90px' textAlign='center'>
						No survey data available for {moment().format(chartFormat)}
					</Medium>
				</NoData>
			)}
		</Card>
	)
}
